import { PetSize } from "@monorepo/functions/src/types/reservations"

export const SIZES: PetSize[] = ['pequeño', 'mediano', 'grande'] as const
